export default {
  'menu.console.settings': '個人設置',
  'menu.welcome': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '管理頁',
  'menu.admin.sub-page': '二級管理頁',
  'menu.login': '登錄',
  'menu.register': '註冊',
  'menu.register-result': '註冊結果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標準列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '異常頁',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '觸發錯誤',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.settings': '個人設置',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.account.profile': '個人資訊',


  'menu.admin.dashboard': '儀表盤',
  'menu.admin.settings': '系統配置',
  'menu.admin.providers': '模型供應商',
  'menu.admin.unbindDevice': '設備解綁',
  'menu.admin.userManage': '用戶管理',
  'menu.admin.systemConfig': '高級配置',
  'menu.admin.whiteList': '白名單',
  'menu.admin.opsManage': '運維管理',
  'menu.admin.recorderManage': '錄音管理',

  'menu.console': '控制檯',
  'menu.console.agents': '智能體',
  'menu.console.agentDevice': '管理設備',
  'menu.console.devices': '設備管理',
  'menu.console.speakers': '聲紋識別',
  'menu.console.voiceClone': '聲音克隆',

  'menu.console.agentSetting': '智能體設置',
  'menu.admin.deviceManage': '設備管理',
}
